import { useMemo, useState } from "react";
import Setup from "../services/common-components/Setup";
import { formatNameToScopeId } from "../utils/util-id-parser";
import { appVersion } from "../version";

const SnippetRoute = () => {
  const queryParameters = useMemo(
    () => new URLSearchParams(window.location.search),
    [],
  );
  const [isLoading, setIsLoading] = useState(true);

  const params = useMemo(() => {
    let organizationId =
      queryParameters.get("organization_id") ||
      queryParameters.get("organizationId");
    organizationId = formatNameToScopeId(organizationId);
    let accountId =
      queryParameters.get("account_id") || queryParameters.get("accountId");
    accountId = formatNameToScopeId(accountId);
    let setupId =
      queryParameters.get("setup_id") ||
      queryParameters.get("setupId") ||
      queryParameters.get("workspaceId") ||
      queryParameters.get("workspace_id");

    setupId = formatNameToScopeId(setupId);

    return {
      token: queryParameters.get("token"),
      organizationId,
      accountId,
      setupId,
      accountName:
        queryParameters.get("account_name") ||
        queryParameters.get("accountName"),
      setupName:
        queryParameters.get("setup_name") ||
        queryParameters.get("setupName") ||
        queryParameters.get("workspace_name") ||
        queryParameters.get("workspaceName"),
      agentName:
        queryParameters.get("agent_name") || queryParameters.get("agentName"),
      agentId:
        queryParameters.get("agent_id") || queryParameters.get("agentId") || "",
      channelId:
        queryParameters.get("channelId") ||
        queryParameters.get("channel_id") ||
        "",
      showActionButtons: queryParameters.get("show_action_buttons") === "true",
      canEditChannel: queryParameters.get("can_edit_channel") !== "false",
      agentLanguage:
        queryParameters.get("agent_language") ||
        queryParameters.get("agentLanguage") ||
        "en-US",
    };
  }, [queryParameters]);

  return (
    <div className="w-full flex flex-col">
      <Setup {...params} isLoading={isLoading} setIsLoading={setIsLoading} />
      {!isLoading && (
        <span className="pl-4 text-[10px] text-start">
          version: {appVersion}
        </span>
      )}
    </div>
  );
};

export default SnippetRoute;
